<template>
    <div @touchmove.prevent>
        <popup v-model="popupVisible" position="bottom" class="select-picker-popup">
            <div class="select-popup-header">
                <span class="popup-btn cancel-btn" @click="handleCancel">取消</span>
                <p class="popup-title">{{title}}</p>
                <span class="popup-btn submit-btn" @click="handleConfirm">确定</span>
            </div>
            <picker v-show="!isLoading" ref="selectPicker" :slots="slots" @change="handleValuesChange" :valueKey="valueKey"></picker>
            <div v-if="isLoading" class="loading-box">
                <spinner type="triple-bounce" size="1rem" />
            </div>
        </popup>
    </div>
</template>

<script>
import { Picker } from "mint-ui";
import { Popup } from "mint-ui";
import Spinner from "../Spinner/index.vue";
import { getAddress } from "../../api/common.js";

export default {
    name: "AddressPicker",
    components: {
        Picker,
        Popup,
        Spinner
    },
    props: {
        visible: {
            type: Boolean
        },
        title: {
            type: String,
            default: "请选择地区"
        },
        valueKey: {
            type: String,
            default: "label"
        }
    },

    watch: {
        visible(val) {
            console.log("visible change");
            this.popupVisible = val;
        },

        popupVisible(val) {
            console.log("popupVisible change");
            if (!val) {
                this.$emit("hide");
            }
        }
    },

    mounted() {
        // 获取所有地址的数据
        getAddress({ type: 0 }).then(res => {
            if (+res.code === 200) {
                this.addressData = res.data;
                this.isLoading = false;
                if (
                    this.initSuccess &&
                    typeof this.initSuccess === "function"
                ) {
                    this.initSuccess();
                } else {
                    this.setSelected(["", "", ""]);
                }
            }
        });
    },

    data() {
        return {
            popupVisible: false,
            addressList: [],
            isLoading: true,
            slots: [
                {
                    flex: 1,
                    values: [],
                    className: "select-slot",
                    textAlign: "center",
                    defaultIndex: 0
                },
                {
                    flex: 1,
                    values: [],
                    className: "select-slot",
                    textAlign: "center",
                    defaultIndex: 0
                },
                {
                    flex: 1,
                    values: [],
                    className: "select-slot",
                    textAlign: "center",
                    defaultIndex: 0
                }
            ]
        };
    },
    methods: {
        // 获取子列表
        getChildList(index, selectedValues, key) {
            let { addressData } = this;
            let parent = addressData;
            for (let i = 0; i < index; i++) {
                let value = selectedValues[i] || "";
                let selectedIndex = parent.findIndex(item => {
                    return item ? item[key] === value : item === value;
                });
                selectedIndex = selectedIndex > 0 ? selectedIndex : 0;
                parent = parent[selectedIndex]["children"];
            }
            return parent || [];
        },

        handleValuesChange(picker, values) {
            this.currentSelected = values;
            this.currentSelectedValues = this.getSelectedValue(values);
            this.$emit("change", this.currentSelectedValues);
            // 滑动父级，更新子级的数据
            if (this.addressData) {
                this.setSelected(this.currentSelectedValues);
            }
        },

        handleConfirm() {
            this.$emit("hide");
            this.$emit("confirm", this.currentSelected);
        },

        handleCancel() {
            this.$emit("hide");
        },

        // 获取选中的value
        getSelectedValue(values) {
            return values.map(item => {
                return item ? item.value : "";
            });
        },

        // 设置选中的值
        setSelected(values, key = "value") {
            if (this.isLoading || !this.$refs.selectPicker) {
                // 如果数据还没加载完成的话，则挂一个回调，在加载成功的时候再调用
                this.initSuccess = () => {
                    this.setSelected(values, key);
                    this.initSuccess = null;
                };
                return;
            }
            let selecteds = [];
            for (let i = 0; i < this.slots.length; i++) {
                // 更新列数据
                let childList = this.getChildList(i, values, key);
                this.$refs.selectPicker.setSlotValues(i, childList);

                // 收集选中的数据
                let value = values[i] || "";
                let selected = childList.find(option => {
                    return key ? option[key] === value : option === value;
                });
                if (!selected) {
                    selected = childList[0];
                }
                selecteds.push(selected);
            }
            // 更新选中的
            this.$refs.selectPicker.setValues(selecteds);
        }
    }
};
</script>

<style scoped lang="scss">
.select-picker-popup {
    width: 100%;
}

.select-popup-header {
    display: flex;
    height: 1rem;
    line-height: 1rem;
    border: 1px solid #e5e5e5;
    font-size: 0.28rem;

    .popup-title {
        flex: 1;
        text-align: center;
        font-size: 0.32rem;
    }

    .cancel-btn {
        padding-left: 0.3rem;
        color: #848484;
        text-align: left;
    }

    .submit-btn {
        padding-right: 0.3rem;
        color: #26a2ff;
        text-align: right;
    }

    .popup-btn {
        flex-basis: 1.3rem;
    }
}

.loading-box {
    height: 3rem;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>

<style>
.select-picker-popup .picker-item {
    font-size: 0.28rem;
    padding: 0;
}

.select-picker-popup .picker-selected {
    font-size: 0.32rem;
}
</style>
